(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["se-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.seCardAdd) return;
    window.seCardAdd = true;
    document.addEventListener('submit', (e) => {
      const form = e.target.closest && e.target.closest('form[data-se-add]');
      if (!form || !window.fetch) return;
      e.preventDefault();
      const btn = form.querySelector('button');
      const label = btn.firstElementChild;
      btn.disabled = true;
      fetch(form.action + '.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then((r) => { if (!r.ok) throw r; return r.json(); })
        .then((item) => {
          btn.classList.add('is-added');
          label.textContent = 'Added';
          document.dispatchEvent(new CustomEvent('se:cart-added', { detail: item }));
          setTimeout(() => { btn.classList.remove('is-added'); label.textContent = 'Add'; btn.disabled = false; }, 2400);
        })
        .catch(() => form.submit());
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
